export const formatBytes = (bytes) => {
  if (bytes == null) return '—';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
};

export const truncar = (texto, limite = 60) =>
  !texto ? '' : texto.length <= limite ? texto : `${texto.slice(0, limite)}…`;

export const formatJson = (valor) => {
  try {
    return JSON.stringify(valor, null, 2);
  } catch {
    return String(valor);
  }
};

export const iniciais = (nome) =>
  (nome || '?')
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase())
    .join('');
